import _extends from "@babel/runtime/helpers/extends";
import { forwardRef } from "react";
import hintCss from "hint.css/hint.min.css?inline-raw";
import { usePlainCss } from "../hooks";
/**
 * This is a very basic `hint.css` implementation for a tooltip.
 *
 * @see https://kushagra.dev/lab/hint/
 */
// eslint-disable-next-line react/display-name

const Tooltip = /*#__PURE__*/forwardRef(({
  children,
  className,
  title,
  position = "top",
  color,
  size = "large",
  always,
  rounded,
  noAnimate,
  bounce,
  ...rest
}, ref) => {
  usePlainCss(hintCss, "hint-css", true);
  return h("div", _extends({
    style: {
      position: "relative",
      display: "inline"
    },
    ref: ref,
    "aria-label": title,
    className: "hint--".concat(position, " hint--").concat(size, " ").concat(color ? "hint--".concat(color) : "", " ").concat(always ? "hint--always" : "", " ").concat(rounded ? "hint--rounded" : "", " ").concat(noAnimate ? "hint--no-animate" : "", " ").concat(bounce ? "hint--bounce" : "", " ").concat(className || "")
  }, rest), children);
});
export { Tooltip };